import React from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { ApiTokenUsageExample } from "~/pages/AppsAndIntegrations/Intergations/ApiTokens/ApiTokenUsageExample";
import { TokenDialog } from "~/pages/AppsAndIntegrations/Intergations/TokenDialog";
import { useApiToken } from "~/repository";

const ApiTokenDialog = ({ onClose, userId, tokenId }) => {
  const { t } = useTranslation();
  const { data, isFetching } = useApiToken(userId, tokenId);
  const apiSubscriptionData = data?.single;

  return (
    <TokenDialog
      open={!!tokenId}
      onClose={onClose}
      urlLabel={t("API URL")}
      urlValue={apiSubscriptionData?.api_url}
      tokenLabel={t("Token")}
      tokenValue={apiSubscriptionData?.token}
      isFetching={isFetching}
    >
      <ApiTokenUsageExample
        apiUrl={apiSubscriptionData?.api_url}
        token={apiSubscriptionData?.token}
      />
    </TokenDialog>
  );
};

ApiTokenDialog.propTypes = {
  onClose: PropTypes.func,
  userId: PropTypes.number,
  tokenId: PropTypes.number,
};

ApiTokenDialog.defaultProps = {
  userId: null,
};

export default ApiTokenDialog;
